/* istanbul ignore file */ /* plugin extension code */
/* cSpell:ignore Slidedown */

import type { OpenedEvent } from 'react-native-onesignal';
import OneSignal from 'react-onesignal';

/**
 * @see https://onesignal.com/blog/how-to-integrate-push-notifications-in-react/
 */
import { getEnvVars } from '@order/utils';

import type { OneSignalUser } from './oneSignal.types';

const { ONE_SIGNAL_APP_ID = '' } = getEnvVars();

const areOneSignalCredentialsProvided = Boolean(ONE_SIGNAL_APP_ID);
const isRunningLocally = window.location.hostname === 'localhost'; // only remote domains are supported by our One Signal setup
const isOneSignalEnabled = areOneSignalCredentialsProvided && !isRunningLocally;

export async function initOneSignal(
  _onNotificationOpen?: (openedEvent: OpenedEvent) => void,
) {
  if (!isOneSignalEnabled) return;

  await OneSignal.init({ appId: ONE_SIGNAL_APP_ID });
  await OneSignal.showSlidedownPrompt();

  return true;
}

export async function startOneSignalUserSession(user: OneSignalUser) {
  if (!isOneSignalEnabled) return;

  if (user.id) await OneSignal.setExternalUserId(user.id);

  if (user.email) await OneSignal.setEmail(user.email);
}

export async function resetOneSignalUserSession() {
  if (!isOneSignalEnabled) return;

  await OneSignal.removeExternalUserId();
}

export { default as OneSignal } from 'react-onesignal';
